/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ZaloNotificationSettingCreate = lazyLoad(
  () => import('./index'),
  module => module.ZaloNotificationSettingCreate
);
